<template>
  <div>
    <FormGridPanel  ref="formGridPanel"
                    :tableColumns="columns" :queryForm="formConfig"
                    @onSubmitQuery="onSubmitQuery"
                    @onRowCellClick="onRowCellClick">
    </FormGridPanel>
  </div>
</template>

<script>
import FormGridPWindow from "components/grid/FormGridPWindow.vue";
import FormGridPanel from "components/grid/FormGridPanel.vue";

const FormConfig={
    titleWidth: 100,
    titleAlign: "right",
    items: [{
        field: "materialType",
        title: "物料类别编码:",
        span: 6,
        itemRender: {
          name: "input",
          attrs: { placeholder: "请输入物料类别编码" }
        }
      },{
        field: "materialTypeDesc",
        title: "物料类别描述:",
        span: 6,
        itemRender: {
          name: "input",
          attrs: { placeholder: "请输入物料类别描述" }
        }
      },{
        span: 6,
      },{
        span: 6,
        align: "right",
        collapseNode: true,
        itemRender: {
          name: "$buttons",
          children: [
            {
              props: {
                type: "submit",
                content: "查询",
                status: "primary"
              }
            },
            {
              props: {
                type: "reset",
                content: "重置"
              }
            }
          ]
        }
      }
    ],
    data: {}
  }

const TableColumns=[
        { type: "radio", 
          title: "选择", 
          width: 60, 
          fixed: "left" 
        },{ type: "seq", 
          width: 80, 
          title: "序号", 
          fixed: "left" 
        },{ 
          field: "materialType",
          title: "物料类别编码",
          editRender: { name: "input" }
        },{
          field: "materialTypeDesc",
          title: "物料类别描述",
          editRender: { name: "input" }
        },{
          field: "startSegment",
          title: "起始段",
          editRender: { name: "input" }
        },{
          field: "endSegment",
          title: "结束段",
          editRender: { name: "input" }
        },{
          field: "currentNumber",
          title: "当前数",
          editRender: { name: "input" }
        },{
          field: "stepUnit",
          title: "步长",
          editRender: { name: "input" }
        },{
          field: "maintainStatus",
          title: "维护状态",
          editRender: { name: "input" },
          formatter(row) {
            return row.row.maintainStatus == "X" ? "已删除" : "未删除";
          }
        }
      ]

export default {
  components: {
    FormGridPWindow,FormGridPanel
  },
  props: {
    tableColumns: {
      Type: Array
    }
  },
  data() {
    return {
        formConfig:FormConfig,
        columns:TableColumns
    };
  },
  created() {
    
  },
  methods: {
      onSubmitQuery(){
        let vm=this;
        vm.$emit("onConditionQuery",vm.data)
      },
      onRowCellClick(row){
        let vm=this;
        vm.$emit("onRowCellClick",row)
      },
      /**
       * 获取选中行
       */
      getSelectedRow(){
        let vm =this;
        return vm.$refs.formGridPanel.getSelectedRow();
      },
      /**
       * 获取表格选项
       */
      getGridOptions(){
         let vm =this;
         return vm.$refs.formGridPanel.getGridOptions();
      },
      /**
       * 加载页面数据
       */
      loadPageData(pageData){
         let vm =this;
         return vm.$refs.formGridPanel.loadPageData(pageData);
      }
  }
};
</script>

<style>
.vxe-grid .warning-row {
    background: oldlace;
  }
</style>
